<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    :stroke="fill"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="m9 18 6-6-6-6"
    />
  </svg>
</template>

<script>
export default {
  name: 'ChevronRightIcon',
  props: {
    size: {
      type: [Number, String],
      default: 12,
    },
    fill: {
      type: String,
      default: '#8A8D93',
    },
  },
};
</script>